import { Employer } from '@backrs_ui/common-ui';

import { transformSearchResultsToNuggets } from '@backrs_ui/grow-ui/src/pages/Search/search.util';
import { useSearchForEmployerPeopleQuery } from '@backrs_ui/grow-ui/src/redux/employer/employer.api';

export const useFetchPeopleSectionData = (employer: Employer) => {
  const { data, isLoading } = useSearchForEmployerPeopleQuery(
    {
      employerName: employer.name,
    },
    {
      skip: !employer.name,
    },
  );

  const people = data ? transformSearchResultsToNuggets(data.results) : { nuggets: [] };

  return { people: people.nuggets, isLoading };
};
